const { FontAwesomeIcon } = require("@fortawesome/react-fontawesome");

const DataChanges = ({ changes }) => {
  return Object.entries(changes).map(([key, value]) => (
    <div
      key={key}
      className="d-flex justify-content-between p-2 rounded bg-light"
    >
      <div className="text-center mb-2 w-25">{key}</div>
      <div className="w-25 text-center">{value.old}</div>
      <div className="w-25 text-center">
        <FontAwesomeIcon icon="arrow-right" />
      </div>
      <div
        className={`w-25 text-center ${value.changed ? "text-danger fw-bold" : ""}`}
      >
        {value.new}
      </div>
    </div>
  ));
};

export default DataChanges;
